export default __webpack_public_path__ + "static/9-d50ad5d3abdb4e70df72f294680ff2a5.png";